import React from 'react';
import { Tooltip } from 'antd';
import { AvatarStackCircle } from '@/pages/inside/tenant/style';

export function UserAvatarWithRoleTooltip({
    name,
    roleLabel,
    initials,
    color,
    size = 28,
    fontSize = 12,
}) {
    return (
        <Tooltip
            title={
                <div style={{ fontSize: 12, lineHeight: 1.35 }}>
                    <div style={{ fontWeight: 600 }}>{name || 'Unnamed member'}</div>
                    <div style={{ opacity: 0.85 }}>{roleLabel || '—'}</div>
                </div>
            }
        >
            <AvatarStackCircle
                $bg={color || 'var(--ant-color-primary)'}
                $color="#fff"
                style={{
                    width: size,
                    height: size,
                    borderRadius: 999,
                    fontSize,
                    fontWeight: 800,
                    lineHeight: 1,
                    boxSizing: 'border-box',
                    border: '1px solid var(--ant-color-border-secondary, #d9d9d9)',
                    cursor: 'default',
                }}
            >
                {initials || ''}
            </AvatarStackCircle>
        </Tooltip>
    );
}

